import { priceInDollars } from '@/lib/priceConversions'
import useCartStore from '@/store/cart'
import Product from '@/types/Product'
import { toast } from '../ui/use-toast'
import { MotionButton } from '../ui/motion-button'
import TechnetLogo from '../Technet/TechnetLogo'
import { isTechnetPriceForProduct } from '@/lib/technet'
import { useIsUSD } from '@/hooks/useIsUSD'

function VCULinks({ vcuPlans }) {
  const { addItemToCart } = useCartStore()
  const isUSD = useIsUSD()

  const enroll = (plan: Product) => {
    const vcuPlans = addItemToCart(plan)
    if (vcuPlans.success) {
      toast({
        title: 'Added Plan to Cart',
        description: `Added plan: ${plan.name} to your cart`,
      })
    } else {
      toast({
        title: vcuPlans.errors.base,
      })
    }
  }

  return (
    <div className="flex gap-2 flex-col sm:flex-row">
      {vcuPlans.plans.map((plan, idx) => (
        <div
          key={plan.id}
          className="relative flex flex-col justify-between rounded bg-white shadow-sm ring-1 ring-gray-900/10 p-4"
        >
          <div className="mb-2 flex-1 flex flex-col">
            <h3 className="font-semibold text-primary mb-2">
              {plan.name}
              {isTechnetPriceForProduct(plan) && (
                <TechnetLogo className="ml-2" size="sm" />
              )}
            </h3>

            <ul className="list-disc list-outside pl-4">
              <li>
                <p className="text-sm text-gray-600 mb-2">{plan.description}</p>
              </li>
              <li>
                <p className="text-sm text-gray-600 mb-2">
                  Subscription renews monthly. No long-term committment - cancel
                  anytime.
                </p>
              </li>
            </ul>
            <div className="flex-grow" />
            <p className="text-xl font-semibold tracking-tight text-gray-900 mb-2">
              {priceInDollars(plan.price)}
              {!isUSD && <span className="text-sm ml-1">USD</span>} / month
            </p>
            <p className="text-xs mb-2">{plan.id}</p>
          </div>
          <MotionButton key={plan.id} onClick={() => enroll(plan)}>
            Add to cart
          </MotionButton>
        </div>
      ))}
    </div>
  )
}

export default VCULinks
